<template>
    <div>
        <div
            class="px-8 py-4 mb-2 space-x-4 text-sm font-semibold bg-neutral-100 dark:bg-neutral-950 text-neutral-900 dark:text-neutral-50"
        >
            {{ lang('products::variants.messages.if_variants_set_no_other_rules') }}
        </div>
        <table
            class="min-w-full border border-gray-300 divide-y divide-gray-300 dark:border-neutral-800 dark:divide-neutral-800"
        >
            <thead class="bg-gray-50 dark:bg-neutral-800"></thead>
            <tbody v-if="hasVariants" class="divide-y divide-gray-200 dark:divide-neutral-800">
                <template v-for="(variant, index) in modelValue" :key="index">
                    <tr>
                        <td colspan="6">
                            <table
                                class="min-w-full border-2 shadow border-neutral-200 dark:border-neutral-600 bg-neutral-50 dark:bg-neutral-900"
                            >
                                <tbody>
                                    <tr class="bg-white border-b shadow border-neutral-200">
                                        <td
                                            class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 align-top whitespace-nowrap"
                                            colspan="5"
                                        >
                                            <Field
                                                v-model="variant.name"
                                                :field="{
                                                    adminComponent: 'AdminText',
                                                    name: lang('products::variants.fields.name'),
                                                }"
                                                size="sm"
                                            ></Field>
                                        </td>
                                        <td class="w-6 py-3.5 pr-4 sm:pr-6">
                                            <div class="flex gap-1">
                                                <Button @click.prevent="removeVariant(variant)">
                                                    <span class="flex items-center justify-center size-8">
                                                        <icon icon="hero/outline/trash" class="size-4"></icon>
                                                    </span>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="(value, valueindex) in variant.values" :key="valueindex">
                                        <td class="w-1/4"></td>
                                        <td
                                            class="w-1/3 pr-3 text-sm font-medium text-gray-900 align-top whitespace-nowrap"
                                        >
                                            <Field
                                                v-model="value.product_attribute_id"
                                                :field="{
                                                    adminComponent: 'AdminSelect',
                                                    name: lang('products::variants.fields.product_attribute_id'),
                                                }"
                                                :options="attributes"
                                                label-position="none"
                                            ></Field>
                                        </td>
                                        <td
                                            class="pl-4 pr-3 text-sm font-medium text-gray-900 align-top whitespace-nowrap"
                                            colspan="3"
                                        >
                                            <Field
                                                v-if="value.product_attribute_id"
                                                v-model="value.product_value_id"
                                                :field="{
                                                    adminComponent: 'AdminSelect',
                                                    name: lang('products::variants.fields.product_value_id'),
                                                }"
                                                :options="getValues(attributes, value)"
                                                label-position="none"
                                            ></Field>
                                        </td>
                                        <td class="w-6 py-3.5 pr-4 sm:pr-6">
                                            <div class="flex gap-1">
                                                <Button @click.prevent="removeValue(variant, value)">
                                                    <span class="flex items-center justify-center size-8">
                                                        <icon icon="hero/outline/trash" class="size-4"></icon>
                                                    </span>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="bg-gray-50 dark:bg-neutral-900">
                                        <th
                                            colspan="5"
                                            class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                        ></th>
                                        <th class="w-12 py-3.5 pr-4 sm:pr-6 text-right">
                                            <Button @click.prevent="addValue(variant)">
                                                <span class="flex items-center justify-center size-8">
                                                    <icon icon="hero/outline/plus" class="size-4"></icon>
                                                </span>
                                            </Button>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td
                                            colspan="4"
                                            class="pl-4 py-3.5 space-y-1 text-left text-sm font-semibold text-gray-900 dark:text-gray-50 border-y dark:border-neutral-700 bg-blue-50 dark:bg-blue-950 border-neutral-200"
                                        >
                                            <span>
                                                {{ lang('products::variants.messages.apply_following_prices') }}
                                            </span>
                                        </td>
                                        <td
                                            class="py-2 pr-6 text-right border-y dark:border-neutral-700 bg-blue-50 dark:bg-blue-950 border-neutral-200"
                                            colspan="2"
                                        >
                                            <Button @click.prevent="managePrices(variant)">
                                                <span class="flex items-center justify-center h-8">
                                                    {{ lang('products::variant-prices.actions.manage') }}
                                                </span>
                                            </Button>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td
                                            colspan="4"
                                            class="pl-4 py-3.5 space-y-1 text-left text-sm font-semibold text-gray-900 dark:text-gray-50 border-y dark:border-neutral-700 bg-blue-50 dark:bg-blue-950 border-neutral-200"
                                        ></td>
                                        <td
                                            class="py-2 pr-6 text-right border-y dark:border-neutral-700 bg-blue-50 dark:bg-blue-950"
                                            colspan="2"
                                        >
                                            <Button @click.prevent="duplicateVariant(variant)">
                                                <span class="flex items-center justify-center h-8">
                                                    {{ lang(`general.datagrid.duplicate`) }}
                                                </span>
                                            </Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </template>
            </tbody>
            <tbody v-else>
                <tr>
                    <td
                        colspan="6"
                        class="py-3.5 space-y-1 text-center text-sm font-semibold text-neutral-900 dark:text-neutral-100"
                    >
                        <p>
                            {{ lang('products::variants.messages.no_variants') }}
                        </p>
                        <p>
                            <Button @click.prevent="addVariant">
                                <span>
                                    {{ lang('products::variants.actions.add_variant') }}
                                </span>
                                <icon icon="hero/outline/plus" class="size-4"></icon>
                            </Button>
                        </p>
                    </td>
                </tr>
            </tbody>
            <tfoot class="bg-gray-50 dark:bg-neutral-900">
                <tr>
                    <th
                        colspan="5"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-neutral-900 dark:text-neutral-100 sm:pl-6"
                    ></th>
                    <th class="w-12 py-3.5 pr-4 sm:pr-6 text-right">
                        <Button @click.prevent="addVariant">
                            <span class="flex items-center justify-center size-8">
                                <icon icon="hero/outline/plus" class="size-4"></icon>
                            </span>
                        </Button>
                    </th>
                </tr>
            </tfoot>
        </table>

        <Modal :show="variantPricesEdited !== null" @close="variantPricesEdited = null">
            <div class="pb-4 bg-white dark:bg-zinc-900 sm:pb-4">
                <div>
                    <div class="mt-3 text-center sm:mt-0 sm:text-left">
                        <h3 class="px-6 py-4 space-x-4 text-lg text-left bg-gray-100 dark:bg-zinc-800">
                            {{ lang('products::variant-prices.actions.manage') }}
                        </h3>

                        <div class="py-4 mt-2">
                            <variants-prices
                                v-if="variantPricesEdited"
                                ref="variantPricesEditor"
                                :variant="variantPricesEdited"
                                :product-id="$page.props.object.id"
                            ></variants-prices>
                        </div>
                    </div>
                </div>
            </div>

            <div class="px-6 py-4 space-x-4 text-right bg-gray-100 dark:bg-zinc-800">
                <Button @click="variantPricesEdited = null">
                    {{ lang('general.cancel') }}
                </Button>

                <Button color="primary" :loading="loading.prices" @click="storePrices()">
                    {{ lang('products::variant-prices.actions.store') }}
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script setup lang="ts">
import { usePage } from '@inertiajs/vue3';
import { ref, computed, onMounted } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';
import VariantsPrices from '@src/Products/Pages/Fields/partials/VariantsPrices.vue';
import { lang } from '@/lang/composable';

const modelValue = defineModel({
    type: [Object, undefined],
    default: () => [],
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<FieldComponent>(), {});

const $page = usePage();

const attributes = ref([]);

const loading = ref({
    prices: false,
});

const hasVariants = computed(() => {
    return modelValue.value && modelValue.value.length > 0;
});

const addVariant = () => {
    const newVariant = {
        name: '',
        values: [],
    };
    modelValue.value.push(newVariant);
};

const removeVariant = (variant) => {
    const index = modelValue.value.indexOf(variant);
    if (index > -1) {
        modelValue.value.splice(index, 1);
    }
};

const duplicateVariant = (variant) => {
    const newVariant = {
        name: `${variant.name} ${lang('products::variants.labels.copy')}`,
        values: [],
    };
    if (variant.values) {
        variant.values.forEach((value) => {
            newVariant.values.push({
                product_attribute_id: value.product_attribute_id,
                product_value_id: value.product_value_id,
            });
        });
    }
    modelValue.value.push(newVariant);
};

const addValue = (variant) => {
    const newValue = {
        product_attribute_id: null,
        product_value_id: null,
    };
    if (!variant.values) {
        variant.values = [];
    }
    variant.values.push(newValue);
};

const removeValue = (variant, value) => {
    const index = variant.values.indexOf(value);
    if (index > -1) {
        variant.values.splice(index, 1);
    }
};

const loadAttributes = () => {
    axios.get(route('products/attributes.admin.api.product', { id: $page.props.object.id })).then(({ data }) => {
        attributes.value = data;
    });
};

const getValues = (attributes, value) => {
    const attribute = attributes.find((attribute) => attribute.id === value.product_attribute_id);
    if (attribute) {
        return attribute.values.map((item) => ({
            id: item.id,
            name: item.name,
        }));
    }
    return [];
};

const variantPricesEdited = ref(null);
const variantPricesEditor = ref(null);

const managePrices = (variant) => {
    variantPricesEdited.value = variant;
};

const storePrices = () => {
    variantPricesEdited.value = null;
};

onMounted(() => {
    loadAttributes();
});
</script>
